import { css } from "@emotion/react";
import React from "react";
import dayjs from "dayjs";
import { useTheme } from "../theme";

const convertMillisecondsToDate = (ms: number): number => {
  return ms / 1000 / 3600 / 24;
};

export interface CalendarDayEventProps extends React.HTMLAttributes<HTMLDivElement> {
  start: dayjs.Dayjs;
  end: dayjs.Dayjs;
  date: dayjs.Dayjs;
  children?: React.ReactNode;
}

export const CalendarDayEvent = ({
  start,
  end,
  date,
  children,
  ...props
}: CalendarDayEventProps) => {
  const isStartOnThisMonth = date.isSame(start, "month");
  const isEndOnThisMonth = date.isSame(end, "month");
  const rightPadding = isEndOnThisMonth ? 1 : 0;
  const leftPadding = isStartOnThisMonth ? 1 : 0;
  const startDate = isStartOnThisMonth ? start : date.startOf("month");
  const endDate = isEndOnThisMonth ? end : date.endOf("month");

  const elapsedDaysOfEvent = convertMillisecondsToDate(
    date.diff(startDate, "date"),
  );

  const daysLength =
    convertMillisecondsToDate(endDate.diff(startDate, "date")) + 1;

  const left = elapsedDaysOfEvent * -100;

  const theme = useTheme();

  return (
    <div
      css={[
        css`
          position: absolute;
          top: 0;
          left: ${left}%;
          display: flex;
          align-items: center;
          width: ${`calc(${daysLength * 100}% - ${
            rightPadding + leftPadding
          }em)`};
          height: 100%;
          overflow: hidden;
          white-space: nowrap;
        `,
        isEndOnThisMonth
          ? {
              marginRight: theme.spacing * 2,
            }
          : null,
        isStartOnThisMonth
          ? {
              marginLeft: theme.spacing * 2,
            }
          : null,
      ]}
      {...props}
    >
      {children}
    </div>
  );
};
